import React from "react";

import { CheckIcon } from "../../icons/CheckIcon/CheckIcon";
import { PlusIcon } from "../../icons/PlusIcon/PlusIcon";

import styles from "./add-button.module.css";

type ColorScheme = "light" | "dark";

type ButtonIcon = "plus" | "check";

type IconSize = 21 | 24;

type AddButtonProps = {
  background: ColorScheme;
  iconColor: ColorScheme;
  icon?: ButtonIcon;
  onClick: () => void;
  selected: boolean;
  iconSize?: IconSize;
};

export const AddButton: React.FC<AddButtonProps> = ({
  background,
  iconColor = "light",
  icon = "plus",
  onClick,
  selected,
  iconSize = 24,
}) => {
  const sizeClass = iconSize === 21 ? styles["icon-21"] : styles["icon-24"];

  return (
    <button
      className={`${styles["add-button"]} ${
        selected ? styles["add-button--dark"] : ""
      } ${sizeClass}`}
      onClick={onClick}
    >
      {icon === "check" || selected ? (
        <CheckIcon color={iconColor} />
      ) : (
        <PlusIcon color={iconColor} />
      )}
    </button>
  );
};
